export default function(){
    var $ = jQuery;
    let $showroom_form = $('.showroom_registration');
    if(!$showroom_form.length){
        return;
    }
    function result_hide(){
        $showroom_form.find('.showroom_registration__result').hide();
    }
    function clear_form(){
        $showroom_form.each(function(){
            this.reset();
        })
    }
    $showroom_form.on('submit', function(e) {
        e.preventDefault();
    });
    $showroom_form.on('reset', function(){
        let $inputs = $showroom_form.find('input');
        // delete all hidden fields except token. It's not done by reset
        $inputs.filter('[type="hidden"]').not('[name="token"],[name="registration_type"]').val('');
        // hide_company_info(false);
        delete_all_loyalty_cards();

        // use timeout to make sure it runs after all fields are cleaned
        setTimeout(function(){
            // help to render all things
            $inputs.change();
        }, 0);
    })

    $showroom_form.keydown(function(event){
        if(event.target && event.target.id.startsWith('loyalty_card') && event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });
    $showroom_form.on('click', 'input[type="submit"], button[type="submit"]', function(e){
        e.preventDefault();
        let $form = $showroom_form;
        let $loader = $('.showroom_registration__loading');
        let $button = $(this);
        var data = $form.serializeArray();
        if($button.attr('name') && $button.val()){
            data.push({
                "name" : $button.attr('name'),
                "value" : $button.val(),
            })
        }
        let is_update = $showroom_form.find('[name="user_id"]').val();
        $form.find('.showroom_registration__title').each(function(){
           let $title = $(this);
           let new_text = $title.data(is_update ? 'update' : 'new');
           if(new_text){
               $title.text(new_text);
           }
        });
        $form.find('[data-original]').each(function(){
            let $field = $(this);
            let $input = $form.find('[name="'+$field.data('original')+'"]');
            $field.text($input.val() ? $input.val() : '-' );
        });

        $.each(data, function(index, item){
            $form.find('.showroom_registration__result-value[data-original="'+item["name"]+'"]').text(item["value"] ? item["value"] : '-');
        })

        function error(message = ''){
            $('.showroom_registration__result').hide();
            let $messages = $form.find('.showroom_registration__result-messages').empty();
            if(typeof message === 'string'){
                $('<li></li>').html(message).appendTo($messages);
            }else{
                let search_did = false;
                $.each(message, function(index_m, error_item){
                    if(error_item['code'] === 'do_search'){
                        if(search_did){
                            return;
                        }
                        let $search = $('.showroom_search');
                        $search.find('[name="club-search"]').val(error_item['message']);
                        $search.submit();
                        search_did = true;
                    }else{
                        $('<li></li>').html(error_item['message']).appendTo($messages);
                    }
                });
            }
            $loader.hide();
            $form.find('.showroom_registration__result--fail').show();
        }

        result_hide();
        $loader.show();
        data.push({'name': 'action', 'value' : 'showroom_registration'});
        jQuery.post(ghostpress_params.ajax_url, data)
            .done(function(result){
                if(result['success']){
                    clear_form();
                    $loader.hide();
                    $form.find('.showroom_registration__result-link').attr('href', result['data']['link']);
                    $form.find('.showroom_registration__result--success').show();
                }else{
                    error(result['data']);
                }
            })
            .fail(function(){
                error('Vyskytla se neočekávaná chyba.');
            });
    })
    .on('click', '.showroom_registration__close-js', function(){
        $(this).closest('.showroom_registration__result').hide();
    });


    /**
     * Loyalty cards
     */
    function add_loyalty_card(){

        let $template = $('#bennon_showroom_registration');
        let id;

        // generate unique id
        do{
            id = 'row-' + Math.floor((Math.random() * 1000));
        }while(document.getElementById('loyalty_card_'+id));

        // replace id everywhere
        let $clone = $($template.html().replaceAll('{id}', id));
        $template.before($clone);
        order_loyalty_cards();
        return $clone;
    }
    function delete_all_loyalty_cards(create_empty = true){
        $('.loyalty_card').remove();
        if(create_empty){
            order_loyalty_cards();
        }
    }
    function order_loyalty_cards(){
        let number = 1;
        let cards = document.querySelectorAll('.loyalty_card');
        if(!cards.length){
            add_loyalty_card();
            return;
        }
        cards.forEach((card) => {
            card.querySelectorAll('.loyalty_card_number').forEach((numberNode) => {
                numberNode.textContent = number;
            });
            ++number;
        })
    }
    function remove_loyalty_card($card){
        $card.remove();
        order_loyalty_cards();
    }
    $(".showroom_registration").on('click', '.loyalty_card_remove', function(){
        remove_loyalty_card($(this).closest('.loyalty_card'));
    }).on('click', '.loyalty_card_add', add_loyalty_card);

    function copy_ean($from, $to){
        let $to_ean = $to.find('.loyalty_card_ean');
        if(!$to_ean.val()){
            $to_ean.val($from.find('.loyalty_card_ean').val()).change();
        }
    }

    $(".showroom_registration_business").on('change', function(){
        let $business = $('.loyalty_cards--business');
        let $personal = $('.loyalty_cards--personal');
        if ($(this).is(':checked')) {
            order_loyalty_cards(); // this will also add a card if none is there
            copy_ean($personal, $business);
            $business.show();
            $personal.hide();
        } else {
            copy_ean($business, $personal);
            $business.hide();
            $personal.show();
        }
    })

    /**
     * Company info loading
     */
    function hide_company_info(clear = true){
        $('.showroom_registration__company-info').hide();
        // delete filled info
        if(clear){
            $('.company_field').val('');
        }
    }
    function render_company_loading(){
        hide_company_info();
        $('.showroom_registration__company-loading').show();
    }
    function render_company_preview(data = false){
        if(data !== false){
            hide_company_info();
            $.each(data, function(name, value){
                $('[name="'+name+'"]').val(value);
                if(name === 'billing_ic'){
                    $('[name="customer_ic"]').val(value);
                }
            });
        }else{
            hide_company_info(false);
        }
        let $preview = $('.showroom_registration__company-preview');
        $("input.company_field").each(function (){
            let $input = $(this);
            let value = $input.val();
            if(!value && ($input.attr('name') === 'billing_dic' || $input.attr('name') === 'billing_ic')){
                value = '–';
            }
            $preview.find('.'+$input.attr('name')).text(value);
        })
        $preview.show();
    }
    function render_company_error(error){
        hide_company_info();
        let $error = $('.showroom_registration__company-error');
        $error.text(error);
        $error.show();
    }

    const ic_regex = /^\d{8}$/;
    $('[name="customer_ic"]').on('input', function(){
        let ic = $(this).val();
        // autoload company info only for new customer and if it could be valid
        if(ic && ic_regex.test(ic) && !$('[name="user_id"]').val())
        {
            fill_company_info();
        }
    }).on('change', function(){
        if(!$(this).val())
        {
            hide_company_info();
        }
    })
    $(".showroom_registration__ares").click(fill_company_info);

    let company_ajax = null;
    let current_company_ic = null;
    let current_country = null;
    let result_cache = [];
    function maybe_cache_result(ic, country, result){
        if(typeof result['success'] !== 'undefined' && result['data'] !== 'request'){
            result_cache.push({
                'ic': ic,
                'country': country,
                'result': result,
            })
            while (result_cache.length > 15){
                result_cache.shift();
            }
        }
    }

    function get_cached_result(ic, country){
        let cached = false;
        result_cache.forEach((item) => {
            if(item.ic === ic && item.country === country){
                cached = item.result;
            }
        })
        return cached;
    }
    function fill_company_info(){
        let ic = $('[name="customer_ic"]').val();
        let country = $('[name="customer_country"]').val();
        console.log(country);
        if(ic === current_company_ic && country === current_country){
            return;
        }
        if(company_ajax){
            company_ajax.abort();
        }
        if(!country){
            company_error('empty-country');
            return;
        }
        if(!ic){
            company_error('empty');
            return;
        }

        render_company_loading();

        function company_error(error){
            switch (error){
                default:
                case 'request':
                    error = "Chyba při komunikaci se serverem. Zkuste to znovu.";
                    break;
                case 'format':
                    error = "Špatný formát IČ. Nemáte někde překlep?";
                    break;
                case 'empty':
                    error = "Není zadané IČ.";
                    break;
                case 'empty-country':
                    error = "Není vybraná země.";
                    break;
                case 'not-found':
                    error = "Zadané IČ ve vybrané zemi nenalezeno.";
                    break;
            }
            render_company_error(error);
        }

        let data = {
            'ico': ic,
            'country': country,
        };

        function process_success(result){
            if(result['success']){
                render_company_preview(result['data']);
            }else{
                company_error(result['data']);
            }
        }
        let cached_result = get_cached_result(ic, country);
        if(cached_result){
            process_success(cached_result);
        }else{
            // after abort because it clears current_company_ic
            current_company_ic = ic;
            current_country = country;
            data['action'] = 'ghostpress_company_info';

            company_ajax = jQuery.post(ghostpress_params.ajax_url,data)
                .done(function(result){
                    process_success(result);
                    maybe_cache_result(ic, country, result);
                })
                .fail(function(){
                    company_error('request');
                })
                .always(function(){
                    company_ajax = null;
                    current_company_ic = null;
                    current_country = null;
                });
        }
    }

    /**
     * Edit user
     */
    $(document).on('click', '.showroom_registration__edit', function(){
        let $button = $(this);
        let data = $button.data('user');
        fill_user_data(data);
    })

    function fill_user_data(data){
        clear_form();

        // set business account first
        $showroom_form.find('[name="business_account"]').prop('checked', data['business_account']).change();

        delete_all_loyalty_cards(false);
        // add_loyalty cards afterwards
        if(Array.isArray(data['loyalty_cards'])){
            if(data['business_account']){
                data['loyalty_cards'].forEach((item) => {
                    let $card = add_loyalty_card();
                    $card.find('.loyalty_card_ean').val(item['ean']);
                    $card.find('.loyalty_card_holder').val(item['holder']);
                });
            }else{
                if(data['loyalty_cards'].length){
                    $('[name="loyalty_card[single][ean]"]').val(data['loyalty_cards'][0]['ean']);
                }
            }
        }
        order_loyalty_cards();

        // copy other fields
        $.each(data, function(index, value){
            let $input = $showroom_form.find((index === 'customer_country' ? 'select' : 'input') + '[name="'+index+'"]').not('[type="checkbox"]');
            $input.val(value).change();
        });
        if(data['billing_ic']){
            render_company_preview()
        }
    }

    // update submit button text and show reset button
    $('[name="user_id"]').on('change', function(){
        let $submit = $showroom_form.find('.signup__button');
        let $cancel = $showroom_form.find('.showroom_registration__cancel_update');
        if($(this).val()){
            $submit.text($submit.data('update'));
            $cancel.show();
            // set email as readonly
            $showroom_form.find('[name="user_email"]').attr('disabled', 'disabled');

            // set business account and ic readonly if it's a business account
            let $business_account = $('[name="business_account"]');
            let $read_only_business = $('[name="business_account"], [name="customer_ic"], [name="customer_country"]');
            if($business_account.is(':checked')){
                $read_only_business.attr('disabled', 'disabled');
                // enable country if nothing is selected
                let $country = $('[name="customer_country"]');
                if(!$country.val()){
                    $country.removeAttr('disabled');
                }
            }else{
                $read_only_business.removeAttr('disabled');
            }
        }else{
            $submit.text($submit.data('register'));
            $cancel.hide();
            $('[disabled]').not('option').removeAttr('disabled');
        }
    })
    $showroom_form.find('.showroom_registration__cancel_update').on('click', clear_form);

    /**
     * Search user
     */
    $('.showroom_search').on('submit', function(e){
        e.preventDefault();
        let form = this;
        let $form = $(this);
        let $result = $('.showroom_search__result');
        let $loader = $('.showroom_search__loading');
        var data = $form.serializeArray();
        // reset form
        // $form.find('input').not('[type="hidden"]').val('');

        function error(message = ''){
            $result.empty();
            if(typeof message === 'string'){
                $('<p></p>').text(message).appendTo($result);
            }else{
                $.each(message, function(index_m, error_item){
                    $('<p></p>').text(error_item['message']).appendTo($result);
                });
            }
            $loader.hide();
            $result.show();
        }

        form.reset();
        $result.hide();
        $loader.show();
        jQuery.post(ghostpress_params.ajax_url,data)
            .done(function(result){
                if(result['success']){
                    $.each(result['data'], function(selector, html){
                        $(selector).html(html);
                    });
                    $loader.hide();
                    $result.show();
                }else{
                    error(result['data']);
                }
            })
            .fail(function(){
                error('Vyskytla se neočekávaná chyba.');
            });
    });

}
